<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div
      id="billing"
      class="modal fade"
      :class="{ show: show }"
      style="background: rgba(0,0,0,0.5)"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" v-click-outside="onCancel" id="modal">
          <div class="card-body">
            <!-- <h5
              class="mx-0 px-2 pb-3"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              {{ $t("add_user") }}
            </h5> -->
            <img
              src="../../assets/images/logo.png"
              alt="logo"
              height="45"
              class="mx-auto d-block mb-3"
            />
            <div>
              <h6 class="text-center mb-2 font-weight-bolder">
                {{ $t("billing-info") }}
              </h6>
              <p class="text-center gray3">{{ $t("enter-payment-details") }}</p>
            </div>
            <div
              v-if="mssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              align="center"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <form class="p-2" @submit.prevent="submit">
              <div class="form-group">
                <label>{{ $t("full_name") }}</label>
                <input
                  type="text"
                  name="name"
                  v-model="fullname"
                  class="form-control"
                  required
                  @keypress="isLetter($event)"
                />
              </div>

              <div class="form-group">
                <label>{{ $t("billing-address") }}</label>
                <input
                  type="text"
                  name="address"
                  v-model="address"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group">
                <label>{{ $t("billing-email") }}</label>
                <input
                  type="email"
                  name="email"
                  v-model="email"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group">
                <label for="InputNumber">{{ $t("phone") }}</label>
                <div class="form-group">
                  <input class="form-control" type="tel" id="phone_number" />
                </div>
                <p v-if="ErrorPhone" class="my-0 small text-error p-1">
                  {{ ErrorPhone }}
                </p>
              </div>
              <div class="form-group">
                <label>{{ $t("zip-code") }}</label>
                <input
                  type="text"
                  name="zip"
                  v-model="zipCode"
                  required
                  class="form-control"
                />
              </div>
              <div class="terms mb-4">
                <p class="mb-3">
                  {{ $t("proceed-terms") }}
                </p>
              </div>
              <div
                class="form-group"
                style="display:flex; justify-content: center"
              >
                <!-- <button
                  @click="onCancel"
                  type="button"
                  class="btn btn-secondary"
                >
                  {{ $t("cancel") }}
                </button> -->
                <button type="submit" class="btn btn-primary px-5">
                  {{ $t("Proceed") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import * as intlTelInput from "../../assets/js/intlTelInput";
import * as utils from "../../assets/js/utils";

export default {
  name: "Billing",
  props: {
    show: Boolean,
    plans: Array,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      fullname: "",
      email: "",
      role: "staff",
      mssg: "",
      ErrorPhone: "",
      Errormssg: "",
      iti: "",
      selectNotification: "",
      zipCode: "",
      address: "",
      license: "",
    };
  },
  components: {
    Loading,
  },
  mounted() {
    this.address = this.profile.address;
    this.email = this.profile.email;
    setTimeout(() => {
      var input = document.querySelector("#phone_number");
      this.iti = intlTelInput(input, {
        separateDialCode: true,
        utilsScript: utils,
      });
      this.iti.setCountry("ng");
    }, 200);
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    ...mapActions(["billings"]),
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z\s\b]*$/.test(char)) return true;
      // // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    onCancel() {
      this.$emit("closeLicence");
    },
    // adduser() {
    //   if (this.selectNotification !== "") return;
    //   let number = this.iti.getNumber().slice(1);
    //   this.ErrorPhone = "";
    //   if (!this.iti.isValidNumber()) {
    //     this.ErrorPhone = this.$t("valid_phone");
    //   } else {
    //     this.isLoading = true;
    //     this.Errormssg = "";
    //     const newUser = {
    //       email: this.email.toLowerCase(),
    //       phone: parseInt(number),
    //       fullname: this.fullname,
    //       role: this.role,
    //     };
    //     this.addUser(newUser)
    //       .then((res) => {
    //         this.getUsers().then(() => {
    //           this.onCancel();
    //         });
    //         this.isLoading = false;
    //         this.mssg =
    //           res.data.message[0].toUpperCase() + res.data.message.slice(1);
    //         setTimeout(() => {
    //           this.isLoading = true;
    //         }, 1000);
    //       })
    //       .catch((error) => {
    //         this.isLoading = false;
    //         this.Errormssg =
    //           error.response.data.message[0].toUpperCase() +
    //           error.response.data.message.slice(1);
    //         // error.response can be null
    //         if (error.response) {
    //           console.error(error.response.data.message);
    //         }
    //       });
    //   }
    // },
    submit() {
      console.log(this.license);
      let number = this.iti.getNumber().slice(1);
      this.ErrorPhone = "";
      if (!this.iti.isValidNumber()) {
        this.ErrorPhone = this.$t("valid_phone");
      } else {
        this.isLoading = true;
        this.Errormssg = "";
        const info = {
          email: this.email.toLowerCase(),
          phone: number.toString(),
          fullname: this.fullname,
          address: this.address,
          zip: this.zipCode,
        };
        this.billings(info)
          .then((res) => {
            this.onCancel();
            this.$emit("openPaystack", this.email);
            this.mssg =
              res.data.message[0].toUpperCase() + res.data.message.slice(1);
            setTimeout(() => {
              this.isLoading = false;
            }, 1000);
          })
          .catch((error) => {
            this.isLoading = false;
            this.Errormssg =
              error.response.data.message[0].toUpperCase() +
              error.response.data.message.slice(1);
            // error.response can be null
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      }
    },
  },
  watch: {
    fullname: {
      handler() {
        if (/^[a-zA-Z\s]*$/.test(this.fullname))
          return (this.selectNotification = "");
        else this.selectNotification = this.$t("must_contain");
      },
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 500px !important;
}
.terms {
  border-bottom: 1px solid #dadfe2;
}
.terms p {
  color: #8693a5;
  font-weight: 100;
  font-size: 12px;
}
</style>
<i18n>
{
	"en": {
		"add_user": "Add a User",
		"all_users": "All Users",
		"billing-address": "Billing Address",
		"billing-email": "Billing Email",
		"billing-info": "Billing Information",
		"edit_user": "Edit User",
		"email": "Email",
		"enter-payment-details": "Enter your payment details",
		"full_name": "Full Name",
		"man_user_right": "Manage user rights for members of your business",
		"manage": "Manager",
		"must_contain": "Must conain only Letters",
		"name": "Name",
		"phone": "Phone Number",
		"proceed-terms": "By clicking “Proceed” you agree to the Terms and Conditions.",
		"staff": "Staff",
		"user_rights": "User Rights",
		"valid_phone": "This phone number is not valid",
		"zip-code": "Zip Code"
	},
	"fr": {
		"add_user": "Ajouter un utilisateur",
		"all_users": "Tous les utilisateurs",
		"billing-address": "Adresse de facturation",
		"billing-email": "Email de facturation",
		"billing-info": "Détails de facturation",
		"edit_user": "Modifier l'utilisateur",
		"email": "E-mail",
		"enter-payment-details": "Saisissez vos informations de paiement",
		"full_name": "Nom et prénom",
		"man_user_right": "Gérez les droits d'utilisation des membres de votre entreprise",
		"manage": "Directeur",
		"must_contain": "Ne doit contenir que des lettres",
		"name": "Nom",
		"phone": "Numéro de téléphone",
		"proceed-terms": "En cliquant sur \"Continuer\", vous acceptez les Termes et Conditions.",
		"staff": "Personnel",
		"user_rights": "Droits de l'utilisateur",
		"valid_phone": "Ce numéro de téléphone n'est pas valide",
		"zip-code": "Code postal"
	},
	"sw": {
		"add_user": "ONGEZA MTUMIAJI",
		"all_users": "Watumiaji Wote",
		"billing-address": "Mahali deni litakapotumwa",
		"billing-email": "Barua pepe ya Malipo",
		"billing-info": "Taarifa za bili",
		"edit_user": "Badilisha mtumiaji",
		"email": "Barua pepe",
		"enter-payment-details": "Weka maelezo yako ya malipo",
		"full_name": "Jina kamili",
		"man_user_right": "Dhibiti haki za mtumiaji za wanachama wa biashara yako",
		"manage": "Meneja",
		"must_contain": "Lazima iwe na Barua tu",
		"name": "Jina",
		"phone": "Nambari ya simu",
		"proceed-terms": "Kwa kubofya \"Endelea\" unakubali Sheria na Masharti.",
		"staff": "STAFF",
		"user_rights": "Haki za Mtumiaji",
		"valid_phone": "Nambari hii ya simu si sahihi",
		"zip-code": "Namba ya Posta"
	}
}
</i18n>
